import { actionGenerator } from 'shared/utils/redux';

export enum ENewbuildingBrokerSelfRequestFormWidgetActionTypes {
  SetActive = 'newbuildingBrokerSelfRequestFormWidget/setActive',
  SetLoading = 'newbuildingBrokerSelfRequestFormWidget/setLoading',
}

export const setNewbuildingBrokerSelfRequestFormWidgetActive = actionGenerator<
  ENewbuildingBrokerSelfRequestFormWidgetActionTypes.SetActive,
  boolean
>(ENewbuildingBrokerSelfRequestFormWidgetActionTypes.SetActive);

export const setNewbuildingBrokerSelfRequestFormWidgetLoading = actionGenerator<
  ENewbuildingBrokerSelfRequestFormWidgetActionTypes.SetLoading,
  boolean
>(ENewbuildingBrokerSelfRequestFormWidgetActionTypes.SetLoading);

export type TNewbuildingBrokerSelfRequestFormWidgetActions =
  | ReturnType<typeof setNewbuildingBrokerSelfRequestFormWidgetActive>
  | ReturnType<typeof setNewbuildingBrokerSelfRequestFormWidgetLoading>;
